import { render } from "./UserDetail.vue?vue&type=template&id=2113ab54&scoped=true"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"

import "./UserDetail.vue?vue&type=style&index=0&id=2113ab54&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2113ab54"],['__file',"src/views/qywx/common/sys/UserDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2113ab54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2113ab54', __exports__)) {
    api.reload('2113ab54', __exports__)
  }
  
  module.hot.accept("./UserDetail.vue?vue&type=template&id=2113ab54&scoped=true", () => {
    api.rerender('2113ab54', render)
  })

}


export default __exports__